document.addEventListener('DOMContentLoaded', function () {

	if (!document.querySelector('.works-archive')) return;

	const container = document.querySelector('.works-archive__container');
	const loader = document.querySelector('.works-archive__loader');
	const tabs = document.querySelectorAll('.works-archive__tabs-item');

	let currentPage = 1;
	let hasMorePages = true;
	let isLoading = false;
	const archive = document.querySelector('.works-archive');
	let activeYear = archive.dataset.year || '';

	if (activeYear) {
		tabs.forEach(tab => {
			if (String(tab.dataset.year) === String(activeYear)) {
				tabs.forEach(t => t.classList.remove('active'));
				tab.classList.add('active');
			}
		});
	}
	
	const hash = window.location.hash;
	if (hash.includes('scroll=')) {
		const scroll = parseInt(hash.split('scroll=')[1]);
		setTimeout(() => window.scrollTo(0, scroll), 60);
	}

	function showLoader() {
		loader.innerHTML = `<div class="loader-spinner"><div></div><div></div><div></div><div></div></div>`;
		loader.style.display = 'flex';
	}

	function hideLoader() {
		loader.style.display = 'none';
		loader.innerHTML = '';
	}

	function createMessage(text) {
		const msg = document.querySelector('.works-archive__message');
		msg.textContent = text;
		msg.style.display = 'block';
		return msg;
	}

	function removeMessage() {
		const msg = document.querySelector('.works-archive__message');
		msg.style.display = 'none';
		msg.textContent = '';
	}

	function createCard(work) {
		const acf = work.acf || {};
		const year = work._embedded?.['wp:term']?.flat()
			.find(term => term.taxonomy === 'work_year')?.name || '';
		const meta = [year, acf.technique || '', acf.dimensions || ''].filter(Boolean);
		const thumbnail = work.thumbnail_url || '';
		const permalink = work.link || '';
		const title = work.title.rendered || '';
		if (!thumbnail) return null;

		const mediaHtml = `<img class="work-card__image" src="${thumbnail}" alt="${title}">`;
		const metaHtml = meta.length
			? `<div class="work-card__meta">${meta.map(val => `<span class="work-card__meta-value">${val}</span>`).join('')}</div>`
			: '';

		const cardHtml = `
			<article class="work-card fade-in" id="work-${work.id}">
				<a href="${permalink}" class="work-card__link">
					<figure class="work-card__media">
						${mediaHtml}
						<figcaption class="work-card__content">
							<h2 class="work-card__title">${title}</h2>
							${metaHtml}
						</figcaption>
					</figure>
				</a>
			</article>`;
		const wrapper = document.createElement('div');
		wrapper.innerHTML = cardHtml.trim();
		return wrapper.firstChild;
	}

	function loadWorks() {
		if (isLoading || !hasMorePages) return;
		isLoading = true;
		removeMessage();
		showLoader();

		const siteUrl = somaData['siteURL'];
		let apiUrl = `${siteUrl}/wp-json/wp/v2/works?_embed&page=${currentPage}&acf_format=standard&per_page=12&lang=${somaData.lang}`;

		if (activeYear) apiUrl += `&work_year=${activeYear}`;

		fetch(apiUrl)
			.then(res => {
				if (!res.ok) {
					if (res.status === 400 || res.status === 404) {
						hasMorePages = false;
						return [];
					}
					throw new Error('Erro na API: ' + res.status);
				}
				return res.json();
			})
			.then(data => {
				data = data.filter(work => work.thumbnail_url);

				if (!data.length) {
					if (currentPage === 1) createMessage('Nenhum trabalho disponível.');
					hasMorePages = false;
				} else {
					data.forEach((work, index) => {
						const card = createCard(work);
						if (!card) return;
						container.appendChild(card);
						setTimeout(() => card.classList.add('fade-in-active'), index * 100);
					});
					currentPage++;
				}
			})
			.catch(err => {
				if (currentPage === 1) createMessage('Erro ao carregar trabalhos');
				console.error(err);
			})
			.finally(() => {
				isLoading = false;
				hideLoader();
			});
	}

	function checkScroll() {
		if (window.innerWidth > 1024) {
			if ((window.innerHeight + window.scrollY) >= (document.documentElement.scrollHeight - 300)) {
				if (!isLoading && hasMorePages) loadWorks();
			}
		} else {
			if ((container.scrollLeft + container.clientWidth) >= (container.scrollWidth - 300)) {
				if (!isLoading && hasMorePages) loadWorks();
			}
		}
	}
	window.addEventListener('scroll', checkScroll);
	container.addEventListener('scroll', checkScroll);

	tabs.forEach(tab => {
		tab.addEventListener('click', function () {
			tabs.forEach(t => t.classList.remove('active'));
			this.classList.add('active');

			activeYear = this.dataset.year;
			
			if (activeYear === 'all') activeYear = '';

			currentPage = 1;
			hasMorePages = true;
			container.innerHTML = '';

			loadWorks();
		});
	});

	const ARCHIVE_KEY = 'worksArchiveState';
	document.addEventListener('click', function (e) {
		const link = e.target.closest('.work-card__link');
		if (!link) return;

		sessionStorage.setItem(ARCHIVE_KEY, JSON.stringify({
			url: window.location.href,
			scroll: window.scrollY
		}));
	});

	loadWorks();
});